module.exports = __webpack_public_path__ + "img/TRACTION-SYSTEM.c2efd7c2.jpg";